import React, { FC } from 'react';
import '@src/uikit/Loader/SendMessageRidesSkeleton/style.scss';

interface SendMessageRidesSkeletonProps {
  count?: number;
}

export const SendMessageRidesSkeleton: FC<SendMessageRidesSkeletonProps> = ({
  count = 2,
}) => {
  return (
    <div className="send-message-rides-skeleton">
      <div className="smr-header">
        <div className="smr-header-title shimmer" />
        <div className="smr-header-code shimmer" />
      </div>

      <div className="smr-list">
        {Array.from({ length: count }).map((_, i) => (
          <div className="smr-card" key={i}>
            <div className="smr-card-content">
              <div className="smr-card-top">
                <div className="smr-time shimmer" />
                <div className="smr-status shimmer" />
              </div>
              <div className="smr-route">
                <div className="smr-point">
                  <div className="smr-point-index shimmer" />
                  <div className="smr-point-text">
                    <div className="smr-line shimmer" />
                    <div className="smr-line shimmer short" />
                  </div>
                </div>

                <div className="smr-arrows shimmer" />

                <div className="smr-point">
                  <div className="smr-point-index shimmer" />
                  <div className="smr-point-text">
                    <div className="smr-line shimmer" />
                    <div className="smr-line shimmer short" />
                  </div>
                </div>
              </div>
              <div className="smr-map shimmer" />
            </div>
            <div className="smr-actions">
              <div className="smr-actions-right">
                <button className="smr-btn shimmer" />
                <button className="smr-btn shimmer" />
              </div>
              <button className="smr-btn smr-btn--danger shimmer" />

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default SendMessageRidesSkeleton;
